import { render, staticRenderFns } from "./SurveyQuestionForm.vue?vue&type=template&id=64fcc1a0"
import script from "./SurveyQuestionForm.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports